import React from "react";
import '../2-main-section/main-style.css'
import image1 from './banner2.jpg'
import 'bootstrap/dist/css/bootstrap.css';


const Main = () => {
  return (
    <>
      <div class="First-page">
        <div class="container-1">
            <div class="left-1">
                <div>
                     <p class="font1">Hi, I'm Mohammed Faisal Khan</p>
                     
                     <h1 class="font2">DEVELOPER</h1>
                    
                     <p class="font3">I love to work in UI/UX designng. I always try my best to<br/> make good UI with the best UX.</p>
                      <br/>
                        <button type="button" class="button-1" ><a href="#contact">Hire Me</a></button>
                    </div>
            </div>
          
        </div>
    </div>
    </>
  );
};

export default Main;
